function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecureGreen = function SvgSecureGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m12.1 1-9 4v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5Zm7 11c-.5 4.1-3.3 7.8-7 8.9-3.7-1.1-6.5-4.8-7-8.9V6.3l7-3.1 7 3.1Z",
    transform: "translate(-.1)",
    style: {
      fill: "#3fab64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.1 0h24v24H.1V0Z",
    transform: "translate(-.1)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.6 7.4 12l1.4-1.4 2.2 2.2 4.4-4.4 1.4 1.4Z",
    transform: "translate(-.1)",
    style: {
      fill: "#3fab64"
    }
  }));
};
export default SvgSecureGreen;